export default __webpack_public_path__ + "assets/images/d69154c7a30173f8252827c7025c77f6.svg";